import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 500,
    fontSize: '12px',
    fontWeight: '300',
    cursor: 'pointer',
  },
  popper: { zIndex: theme.zIndex.modalPopover },
}));

const MbTooltip = (props) => {
  const classes = useStyles();

  const { className = '', children, ...rest } = props;
  return (
    <Tooltip
      className={`${className}`}
      classes={{
        ...classes,
        tooltip: classes.tooltip,
        popper: classes.popper,
      }}
      {...rest}
    >
      <div>{children}</div>
    </Tooltip>
  );
};

export default MbTooltip;
